var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDominicanRepublic(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.550903 20.1737C2.02828 25.6552 6.34434 29.9713 11.8258 31.4487V20.1737H0.550903Z",
    fill: "#D80027"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8258 0.551331C6.34434 2.02864 2.02822 6.34477 0.550903 11.8262H11.8258V0.551331H11.8258Z",
    fill: "#0052B4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4486 11.8262C29.9713 6.34477 25.6551 2.02864 20.1737 0.551331V11.8263H31.4486V11.8262Z",
    fill: "#D80027"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1737 31.4486C25.6551 29.9712 29.9713 25.6552 31.4486 20.1737H20.1737V31.4486Z",
    fill: "#0052B4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1742 16.0002C20.1742 18.3054 18.3055 20.1741 16.0002 20.1741C13.695 20.1741 11.8263 18.3054 11.8263 16.0002C11.8263 13.6949 16.0002 11.8262 16.0002 11.8262C16.0002 11.8262 20.1742 13.6949 20.1742 16.0002Z",
    fill: "#496E2D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8263 16.0002C11.8263 13.6949 13.695 11.8262 16.0002 11.8262C18.3055 11.8262 20.1742 13.6949 20.1742 16.0002",
    fill: "#0052B4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6526 13.9131V16.5218C13.6526 17.8185 14.7037 18.8696 16.0004 18.8696C17.2971 18.8696 18.3482 17.8185 18.3482 16.5218V13.9131H13.6526Z",
    fill: "#D80027"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDominicanRepublic);
export default __webpack_public_path__ + "static/media/dominican-republic.f6463586.svg";
export { ForwardRef as ReactComponent };